import { FC, memo } from 'react';

import { ImageData } from '../VariationOne';
import { getWatermarkTag } from '../shared';
import SharedUploadedImageRow from '../shared/UploadedImageRow';
import SettingsModal from './SettingsModal';

interface Props {
  image: ImageData;
  imageIndex: number;
  setImages: React.Dispatch<React.SetStateAction<ImageData[]>>;
}

const UploadedImageRow: FC<Props> = ({ image, imageIndex, setImages }) => {
  const settingsApplied =
    getWatermarkTag(image) !== 'none' || image.divider !== 'none';

  return (
    <SharedUploadedImageRow
      image={image}
      imageIndex={imageIndex}
      setImages={setImages as any}
      showText={false}
      showSettings={true}
      showPreview={false}
      imgRatioX={62}
      imgRatioY={63}
      settingsApplied={settingsApplied}
      settingsModal={
        <SettingsModal
          imageIndex={imageIndex}
          setImages={setImages}
          image={image}
          onClose={() => {}}
        />
      }
    />
  );
};

export default memo(UploadedImageRow);
